import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';

import { useSuggestedStories } from '../hooks/store';
import {
    useIsClubPage,
} from '../hooks/config';

import Component from '../components/StoriesRow';

const StoriesRow = forwardRef(({
    skip,
    ssr,
    properties,
    rank,
    className,
}, ref) => {

    const isClubPage = useIsClubPage();

    let {
        title,
        selection,
        searchType,
        limit = 10,
        skip: skipStories,
    } = properties;

    const options = {
        ssr,
        skip: skip || isClubPage,
        searchType,
        limit,
        skipStories,
    };

    const {
        loading,
        loadingMore,
        data,
        fetchMoreData,
    } = useSuggestedStories(selection, options);

    const list = useMemo(() => (data?.suggestedStories ?? []).map(suggestedStory => ({
        title: suggestedStory.title,
        href: suggestedStory.metadata?.url,
        imageTemplateUrl: suggestedStory.image?.templateUrl,
    })), [data]);

    if (isClubPage) {

        return null;

    }

    return (
        <Component
            ref={ref}
            className={className}
            title={title}
            list={list}
            hasMore={!!data?.hasMore}
            fetchMoreData={fetchMoreData}
            isLoading={skip || loading}
            isLoadingMore={loadingMore}
            limit={limit}
            rank={rank}
            playlist={selection}
        />
    );

});

StoriesRow.propTypes = {
    rank: PropTypes.number.isRequired,
    skip: PropTypes.bool,
    ssr: PropTypes.bool,
    properties: PropTypes.object,
};

StoriesRow.defaultProps = {
    skip: false,
    ssr: true,
    properties: {},
};

export default StoriesRow;
